import prp2boxHttp from '../../services/prp2boxHttp'

export interface IRpLimit {
  id: number
  name: string
  status: number
  min: number
  max: number | null
  maxPayout: number | null
  createdAt: string
  updatedAt: string
}

export interface CreateRpLimitPayload extends Pick<IRpLimit, 'name' | 'min' | 'max' | 'maxPayout'> {}

class Limits {
  prefix: string = '/limits'

  getLimits = async (params: {
    limit?: number
    offset?: number
  }): Promise<{
    rows: IRpLimit[]
    totalRows: number
  }> => {
    const response = await prp2boxHttp.get(`${this.prefix}`, {
      params,
    })

    return response.data
  }

  getLimitById = async (params: { id: number }): Promise<IRpLimit> => {
    const response = await prp2boxHttp.get(`${this.prefix}/${params.id}`)

    return response.data
  }

  createLimit = async (payload: CreateRpLimitPayload): Promise<void> => {
    const response = await prp2boxHttp.post(`${this.prefix}`, payload)

    return response.data
  }

  update = async (id: number, payload: CreateRpLimitPayload): Promise<void> => {
    const response = await prp2boxHttp.put(`${this.prefix}/${id}`, payload)

    return response.data
  }
}

export default new Limits()
